import React from "react";
import { _t } from "core/language";
import AddIcon from "../../assets/icons/commons/add.svg";
import RemoveIcon from "../../assets/icons/commons/remove.svg";
import { ButtonConfirm } from "core/components/form-controls";
import { type TIngredient } from 'modules/Ingredients/store/types';
import { useMyIngredient } from "modules/Ingredients/hooks/myIngredient";

interface GroupActionProps {
  ingredient: TIngredient;
}

const Ingredient: React.FC<GroupActionProps> = ({
  ingredient,
}) => {
  const {
    addToMyIngredients,
    onRemoveMyIngredients,
    checkExist,
  } = useMyIngredient()

  const exist = checkExist(ingredient);

  return exist ? (
    <ButtonConfirm
      size="sm"
      message={_t('recipe.msg.msg_1')}
      handleSubmit={() => ingredient ? onRemoveMyIngredients(ingredient) : null}
      submitText={_t('recipe.msg.confirm')}
      closeText={_t('recipe.msg.cancel')}
      showWithAuth
    >
      <img
        className="cursor-pointer"
        src={RemoveIcon}
        alt="RemoveIcon"
      />
    </ButtonConfirm>
  ) : (
    <ButtonConfirm
      size="sm"
      message={_t('recipe.msg.msg_3')}
      handleSubmit={() => ingredient ? addToMyIngredients([ingredient]) : null}
      submitText={_t('recipe.msg.confirm')}
      closeText={_t('recipe.msg.cancel')}
      id={`add-ingredient-${ingredient.id}`}
      authRequired
      // showWithAuth
    >
      <img
        className="cursor-pointer"
        src={AddIcon}
        alt="AddIcon"
      />
    </ButtonConfirm>
  )
};

export default Ingredient;
